import { LegalPageLayout } from '../components/LegalPageLayout';
import { SEOHead } from '../components/SEOHead';

const PoliticaCookies = () => {
  return (
    <LegalPageLayout title="Política de Cookies" lastUpdated="Febrero 2026">
      <SEOHead 
        title="Política de Cookies"
        description="Política de cookies de EventCinema.es - Información sobre el uso de cookies, tipos utilizados y cómo gestionarlas en tu navegador."
        keywords="política cookies eventcinema, cookies analíticas, google analytics, configurar cookies"
        canonicalUrl="/politica-cookies"
        noIndex={false}
      />
      
      <p>
        En Versión Digital S.L., queremos que tu experiencia de navegación sea tan impecable como una 
        función en la Arena de Verona. Por ello, te informamos de manera clara y transparente sobre 
        el uso de cookies en nuestro marketplace.
      </p>

      <h2>1. ¿Qué es una cookie?</h2>
      <p>
        Una cookie es un pequeño archivo de texto que se descarga en tu navegador (ordenador, móvil 
        o tablet) cuando visitas www.eventcinema.es. Su función es recordar tus preferencias, facilitar 
        la compra de entradas y ayudarnos a saber qué óperas o ballets son los favoritos de nuestra comunidad.
      </p>

      <h2>2. Tipos de cookies que utilizamos</h2>
      <p>Para que nuestro marketplace sea eficiente, utilizamos los siguientes tipos:</p>
      
      <h3>Cookies Técnicas (Necesarias)</h3>
      <p>
        Son imprescindibles para que la web funcione. Permiten, por ejemplo, que el sistema recuerde 
        qué butacas has seleccionado o que puedas acceder a tu zona privada de usuario de forma segura. 
        Sin ellas, no podrías comprar entradas.
      </p>

      <h3>Cookies de Preferencias</h3>
      <p>
        Permiten que el sitio recuerde información que cambia el aspecto o el comportamiento del sitio, 
        como tu idioma preferido o la ciudad donde sueles ir al cine.
      </p>

      <h3>Cookies Analíticas</h3>
      <p>
        Nos permiten contar las visitas y fuentes de tráfico para poder medir y mejorar el desempeño 
        de nuestra plataforma. Nos ayudan a saber qué contenidos (ej. "Cine y Arte") generan más interés.
      </p>

      <h3>Cookies de Marketing o Publicidad</h3>
      <p>
        Se utilizan para rastrear a los visitantes a través de las webs. La intención es mostrar anuncios 
        que sean relevantes y atractivos para ti (como ese concierto que tanto te gusta) basándonos en 
        tus hábitos de navegación.
      </p>

      <h2>3. Cuadro de Cookies en Event Cinema</h2>
      <p>A continuación, detallamos las herramientas de terceros que pueden instalar cookies en tu equipo:</p>
      
      <table>
        <thead>
          <tr>
            <th>Proveedor</th>
            <th>Finalidad</th>
            <th>Tipo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Propias</td>
            <td>Gestión del carrito de compra y sesión de usuario.</td>
            <td>Técnica</td>
          </tr>
          <tr>
            <td>Google Analytics</td>
            <td>Análisis estadístico de visitas y comportamiento.</td>
            <td>Analítica</td>
          </tr>
          <tr>
            <td>Meta (Facebook)</td>
            <td>Medición de campañas publicitarias y retargeting.</td>
            <td>Publicidad</td>
          </tr>
          <tr>
            <td>Stripe / Redsys</td>
            <td>Prevención de fraude en los pagos (esencial).</td>
            <td>Técnica</td>
          </tr>
        </tbody>
      </table>

      <h2>4. ¿Cómo puedes gestionar o desactivar las cookies?</h2>
      <p>
        Tú tienes el papel protagonista. Puedes configurar tus preferencias en cualquier momento a través 
        de nuestro <strong>Panel de Configuración de Cookies</strong> (que aparece al entrar por primera vez).
      </p>
      <p>
        Además, puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la 
        configuración de las opciones de tu navegador:
      </p>
      <ul>
        <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios.</li>
        <li><strong>Safari:</strong> Preferencias → Privacidad → Bloquear todas las cookies.</li>
        <li><strong>Firefox:</strong> Opciones → Privacidad y Seguridad → Cookies y datos del sitio.</li>
      </ul>

      <h2>5. Actualizaciones</h2>
      <p>
        Es posible que actualicemos esta política para reflejar cambios en los servicios de nuestros 
        partners o nuevas directrices legales. Te recomendamos revisarla periódicamente para estar 
        al tanto de cómo protegemos tu experiencia digital.
      </p>

      <div className="highlight-box">
        <p>
          <strong>Cumplimiento Legal:</strong> Para cumplir totalmente con la ley, al entrar en 
          EventCinema.es aparece un Banner de Cookies (CMP) que te permite "Aceptar todas", 
          "Rechazar todas" o "Configurar por capas". No basta con un mensaje informativo; 
          necesitamos tu consentimiento explícito antes de activar las cookies analíticas o de marketing.
        </p>
      </div>
    </LegalPageLayout>
  );
};

export default PoliticaCookies;
